import { apiClient } from './client';

export interface OcrReceipt {
  amount: number | string | null;
  currency: string | null;
  fecha: string | null;
  referencia: string | null;
  destinatario: string | null;
}

export const ocrApi = {
  receipt: async (imageUrl: string): Promise<OcrReceipt> => {
    const { data } = await apiClient.post<OcrReceipt>('/admin/ocr/receipt', { imageUrl });
    return data;
  },
};
